import * as React from 'react';
import { Pressable, View } from 'react-native';
import { cn } from '@/lib/utils';
import { Modal } from './modal';
import { Text } from './text';

interface BlockingModalAction {
  label: string;
  onPress: () => void;
  disabled?: boolean;
}

interface BlockingModalProps {
  visible: boolean;
  title: string;
  children: React.ReactNode;
  primaryAction: BlockingModalAction;
  className?: string;
  testID?: string;
}

function BlockingModal({
  visible,
  title,
  children,
  primaryAction,
  className,
  testID,
}: BlockingModalProps) {
  const handleClose = () => {
    // Intentionally empty -- blocking modals cannot be closed via backdrop or back button
  };

  return (
    <Modal
      visible={visible}
      onClose={handleClose}
      backdropPress={false}
      animationType="fade"
      className={className}
      testID={testID}
    >
      <View className="bg-card rounded-xl p-6">
        <Text className="text-xl font-semibold text-card-foreground mb-4">
          {title}
        </Text>

        <View className="mb-6">{children}</View>

        <Pressable
          onPress={primaryAction.onPress}
          disabled={primaryAction.disabled}
          accessibilityLabel={primaryAction.label}
          accessibilityRole="button"
          className={cn(
            'bg-primary rounded-lg py-3 px-6 items-center',
            primaryAction.disabled && 'opacity-50',
          )}
        >
          <Text className="text-primary-foreground font-semibold text-base">
            {primaryAction.label}
          </Text>
        </Pressable>
      </View>
    </Modal>
  );
}

export { BlockingModal };
export type { BlockingModalProps, BlockingModalAction };
